
import React from 'react';
import { Button } from '@/components/ui/button';
import { UserCheck } from 'lucide-react';
import { Attendee } from '@/types/attendee';
import { cn } from '@/lib/utils';

export interface PerformCheckInButtonProps {
  attendee: Attendee;
  isUpdating: boolean;
  onDirectUpdate: (code: string, updates: any) => Promise<any>;
  setShowTShirtModal?: () => void;
}

const PerformCheckInButton: React.FC<PerformCheckInButtonProps> = ({ 
  attendee, 
  isUpdating, 
  onDirectUpdate,
  setShowTShirtModal
}) => {
  const handleCheckIn = async () => {
    try {
      if (isUpdating) {
        console.log('Already updating, skipping check-in request');
        return;
      }
      
      console.log('Perform check-in for', attendee.name, 'code:', attendee.code);
      
      // Perform direct update via API
      const updates = { attended: true };
      const result = await onDirectUpdate(attendee.code, updates);
      
      // If the update was successful, we can show T-shirt modal if the caller wants
      if (result && setShowTShirtModal) {
        setShowTShirtModal();
      }
      
      // Dispatch a custom event to notify that check-in was done
      const checkInEvent = new CustomEvent('attendance-ui-update', {
        detail: { 
          attendeeCode: attendee.code,
          success: true
        }
      });
      window.dispatchEvent(checkInEvent);
    } catch (error) {
      console.error('Error during check-in:', error);
    }
  };
  
  return (
    <Button
      size="sm"
      variant={isUpdating ? "ghost" : "secondary"}
      className={cn(
        "h-8 px-3 text-blue-600 bg-blue-50 hover:bg-blue-100 hover:text-blue-800 dark:bg-blue-900/30 dark:text-blue-400 dark:hover:text-blue-300 dark:hover:bg-blue-900/50 transition-all duration-150",
        isUpdating && "opacity-50 cursor-not-allowed"
      )}
      onClick={handleCheckIn}
      disabled={isUpdating}
    >
      <UserCheck className="mr-1 h-4 w-4" />
      <span>Check in</span>
    </Button>
  );
};

export default PerformCheckInButton;
